import { FeatureFlagDetails } from "../models/feature-flag-details";
import { get } from "../repositories/enhanced-enrollment";

export async function getFlagDetails(): Promise<FeatureFlagDetails> {
  return get(`/featureFlag/details`);
}
